<template>
  <div id="app" v-bind:class="playing">
    <setter
      v-if="setterMenu"
      v-on:close="setterMenu = false"
      v-on:setGame="setGame($event)"
    />
    <modal v-show="showModal" v-on:close="showModal = false">
      <h3 slot="header">{{ modalMsg }}</h3>
      <!-- <div v-if="showSuggestionMenu" slot="content" id="suggestion-menu">
        <button v-on:click="getGameSuggestion(1)">Rela</button>
        <button v-on:click="getGameSuggestion(2)">Nermel</button>
        <button v-on:click="getGameSuggestion(3)">Lacra</button>
        <button v-on:click="getGameSuggestion(4)">Adios</button>
        <button v-on:click="getGameSuggestion(5)">La perdiste</button>
      </div>
      <div v-if="suggestion" slot="content" id="suggestion">
        <h4>{{ modalComment }}</h4>
        <button v-on:click="getGameSuggestion(gameLevel)">
          Otra Sugerencia!
        </button>
      </div>-->
      <div v-if="suggestion" slot="content" id="suggestion">
        <h4>{{ modalComment }}</h4>
        <button v-on:click="suggestionMenu()">Otra Sugerencia!</button>
      </div>
      <div v-if="displayActiveRules" slot="content" id="active-rules-modal">
        <p v-for="(rules, index) in rulesFlags" :key="index">
          - {{ rules.rule }}.
          <span>Quedan {{ rules.round }} turnos</span>
        </p>
      </div>
      <div v-if="addNewPlayers" slot="content" class="setting player">
        <h2>Agrega otro jugador:</h2>
        <div class="players-settings">
          <div class="player-info name">
            <input type="text" placeholder="Nombre" v-model="name" />
          </div>
          <div class="player-info sex">
            <p>Sexo:</p>
            <button v-on:click="sex = 1" v-bind:class="{ selected: sex == 1 }">
              Hombre
            </button>
            <button v-on:click="sex = 2" v-bind:class="{ selected: sex == 2 }">
              Mujer
            </button>
          </div>
          <div class="player-info orientation">
            <p>Orientación:</p>
            <button
              v-on:click="orientation = 1"
              v-bind:class="{ selected: orientation == 1 }"
            >
              Hetero
            </button>
            <button
              v-on:click="orientation = 2"
              v-bind:class="{ selected: orientation == 2 }"
            >
              Homo
            </button>
            <button
              v-on:click="orientation = 3"
              v-bind:class="{ selected: orientation == 3 }"
            >
              Bi
            </button>
          </div>
        </div>
        <button v-on:click="addPlayer" id="submit-btn">Agregar</button>
      </div>
      <div v-if="addNewPlayers" slot="content" class="delete-player">
        <h2>Borrar jugador</h2>
        <input type="text" placeholder="Nombre" v-model="playerToDelete" />
        <button v-on:click="deletePlayer" id="delete-btn">Borrar</button>
      </div>
      <div v-if="gameEnded" slot="content" id="end-menu">
        <button v-on:click="continueGame">Continuar</button>
        <button v-on:click="donate" id="donate-btn">Donar</button>
      </div>
      <div v-if="donation" slot="content">
        <button
          style="margin-top:2%;"
          class="checkout-button"
          role="link"
          v-on:click="pay('sku_FF5DgjpF4jjjdp')"
        >
          Donacion Panita - $2.99
        </button>
        <button
          style="margin-top:2%;"
          class="checkout-button"
          role="link"
          v-on:click="pay('sku_FF5FFMPBwBKZdu')"
        >
          Donacion Crack - $4.99
        </button>
        <button
          style="margin-top:2%;"
          class="checkout-button"
          role="link"
          v-on:click="pay('sku_FF5EcRHub0rqOJ')"
        >
          Donacion Lacra - $9.99
        </button>
        <button
          style="margin-top:2%;"
          class="checkout-button"
          role="link"
          v-on:click="pay('sku_FF5FDzP4dkP1av')"
        >
          Donacion Alta Lacra - $29.99
        </button>
      </div>
    </modal>
    <div id="round-number">
      <h2>{{ currentRound }}</h2>
    </div>
    <div id="content">
      <h1>{{ challenge }}</h1>
      <h2 v-show="punishment">{{ punishment }}</h2>
      <p>{{ comment }}</p>
    </div>
    <div id="next" v-on:click="next" role="button">
      <div class="arrow">
        <div class="bar-1"></div>
        <div class="bar-2"></div>
      </div>
    </div>
    <button
      id="instructions-btn"
      v-if="playing == 'games'"
      v-on:click="showInstructions"
    >
      Instrucciones
    </button>
    <button
      id="suggestion-btn"
      v-if="hasSuggestions"
      v-on:click="suggestionMenu"
    >
      Sugerir!
    </button>
    <div id="active-rules">
      <h2>Reglas Activas:</h2>
      <div v-on:click="seeRules">
        <h3>{{ rulesFlags.length }}</h3>
      </div>
    </div>
    <div id="logo">
      <img src="@/assets/logo.png" alt="Se Predio logo" />
    </div>
    <Menu
      v-on:showPlayers="showPlayers"
      v-on:restartGame="restartGame"
      v-on:showRules="showRules"
      v-on:resetGame="resetGame"
      v-on:donate="donate"
    />
  </div>
</template>

<script>
import Menu from "./components/Menu.vue";
import Modal from "./components/Modal.vue";
import SetterMenu from "./components/SetterMenu.vue";
import rules from "./data/rules.json";
import dares from "./data/dares.json";
import questions from "./data/questions.json";
import games from "./data/games.json";

export default {
  name: "app",

  data() {
    return {
      setterMenu: false,
      addNewPlayers: false,
      name: "",
      sex: 0,
      orientation: 0,
      playing: "",
      roundsToPlay: undefined,
      type: 1, // 1 - Friendly , 2 - Culish , 3 - XXX
      level: 1, // 1 - Chill, 2 - Normal, 3 - Hard, 4 - Bye, 5 - Holy shit
      players: [], // name // sex: 1 - Male, 2 - Female // orientation: 1 - Hetero, 2 - Homo, 3 - Bi
      que: 0,
      currentRound: 0,
      challenge:
        "Sírvanse sus tragos y cuando esten ready denle a la flechita!",
      punishment:
        "Recuerden revisar el insta para saber el licor del mes y las bebidas de la semana!",
      comment: "SE PRENDIÓ ESTA MIERDA 🔥🔞",
      game: undefined,
      gameRules: "",
      gameLevel: 1,
      hasSuggestions: "",
      rulesFlags: [],
      displayActiveRules: false,
      showModal: false,
      modalMsg: "",
      modalComment: "",
      showSuggestionMenu: false,
      suggestion: "",
      gameEnded: false,
      donation: false,
      complete: false,
      playerToDelete: ""
    };
  },
  components: {
    Menu,
    modal: Modal,
    setter: SetterMenu
  },
  beforeCreate() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js");
    }
    // ATTEMP TO FIX THE KEYBOARD ACTIVE LAYOUT SHRINK
    // setTimeout(function () {
    //     let viewheight = window.innerHeight;
    //     let viewwidth = window.innerWidth;
    //     // Chrome Fix
    //     // let viewheight = window.visualViewport.height;
    //     // let viewwidth = window.visualViewport.width;
    //     let viewport = document.querySelector("meta[name=viewport]");
    //     viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
    // }, 300);
  },
  created() {
    if (typeof window.addEventListener === "undefined") {
      window.addEventListener = function(e, callback) {
        return window.attachEvent("on" + e, callback);
      };
    }
    window.addEventListener("beforeunload", function(e) {
      e.preventDefault();
      e.returnValue = "";
    });
  },
  mounted() {
    // check local storage if empty start new game
    let savedGame = JSON.parse(localStorage.getItem("savedGame"));
    if (savedGame) {
      this.setterMenu = savedGame.setterMenu;
      this.addNewPlayers = savedGame.addNewPlayers;
      this.playing = savedGame.playing;
      this.roundsToPlay = savedGame.roundsToPlay;
      this.type = savedGame.type;
      this.level = savedGame.level;
      this.players = savedGame.player;
      this.currentRound = savedGame.currentRound;
      this.challenge = savedGame.challenge;
      this.punishment = savedGame.punishment;
      this.comment = savedGame.comment;
      this.game = savedGame.game;
      this.gameRules = savedGame.gameRules;
      this.gameLevel = savedGame.gameLevel;
      this.hasSuggestions = savedGame.hasSuggestions;
      this.rulesFlags = savedGame.rulesFlags;
      this.displayActiveRules = savedGame.displayActiveRules;
      this.showModal = savedGame.showModal;
      this.modalMsg = savedGame.modalMsg;
      this.modalComment = savedGame.modalComment;
      this.showSuggestionMenu = savedGame.showSuggestionMenu;
      this.suggestion = savedGame.suggestion;
      this.gameEnded = savedGame.gameEnded;
      this.donation = savedGame.donation;
      this.complete = savedGame.complete;
    } else {
      this.setterMenu = true;
    }
  },
  computed: {
    currentRules() {
      return rules.map(rule => {
        return rule;
      });
    },
    currentDares() {
      return dares.map(dare => {
        return dare;
      });
    },
    currentQuestions() {
      return questions.map(question => {
        return question;
      });
    },
    currentGames() {
      return games.map(game => {
        return game;
      });
    }
  },
  methods: {
    setGame(settings) {
      this.roundsToPlay = settings.roundsToPlay;
      this.players = settings.players;
      this.type = settings.type;
      this.level = 1;
    },
    saveGame() {
      let savedGame = JSON.stringify({
        setterMenu: this.setterMenu,
        addNewPlayers: this.addNewPlayers,
        playing: this.playing,
        roundsToPlay: this.roundsToPlay,
        type: this.type,
        level: this.level,
        player: this.players,
        currentRound: this.currentRound,
        challenge: this.challenge,
        punishment: this.punishment,
        comment: this.comment,
        game: this.game,
        gameRules: this.gameRules,
        gameLevel: this.gameLevel,
        hasSuggestions: this.hasSuggestions,
        rulesFlags: this.rulesFlags,
        displayActiveRules: this.displayActiveRules,
        showModal: this.showModal,
        modalMsg: this.modalMsg,
        modalComment: this.modalComment,
        showSuggestionMenu: this.showSuggestionMenu,
        suggestion: this.suggestion,
        gameEnded: this.gameEnded,
        donation: this.donation,
        complete: this.complete
      });
      localStorage.setItem("savedGame", savedGame);
    },
    next() {
      if (!(this.players.length < 2)) {
        if (this.checks()) {
          this.hasSuggestions = false; // Hide button
          this.saveGame();
          let randomInt = this.getRandomInt(100);
          if (
            0 <= randomInt &&
            randomInt <= 10 &&
            this.currentRules.length > 0
          ) {
            this.getRule();
          } // 10% Chance
          if (
            11 <= randomInt &&
            randomInt <= 45 &&
            this.currentQuestions.length > 0
          ) {
            this.getQuestion();
          } // 35% Chance
          if (
            46 <= randomInt &&
            randomInt <= 70 &&
            this.currentDares.length > 0
          ) {
            this.getDare();
          } // 25% Chance
          if (
            71 <= randomInt &&
            randomInt <= 100 &&
            this.currentGames.length > 0
          ) {
            this.getGame();
          } // 30% Chance
        }
      } else {
        this.displayGameAlert("No se puede jugar solo, no seas alcohólico");
      }
    },
    checks() {
      if (this.currentRound + 1 > this.roundsToPlay) {
        this.displayGameAlert(
          "Ya llegaste llegaste al numero de turnos que escogiste... ¡Pero puedes seguir jugando! Ahora es que se puso buena la cosa. Si te estas tripeando el juego tiranos un huesito vale, hazle una donación al equipo de SePrendio y siguenos en Instagram! @seprendio.app"
        );
        this.gameEnded = true;
        return false;
      } else if (
        this.currentRound < this.roundsToPlay ||
        this.roundsToPlay == undefined
      ) {
        this.currentRound++;
        // increase difficulty every 15 turns
        if (this.currentRound % 15 == 0) {
          this.level++;
        }
        this.clearModal();
        if (this.currentRound == this.roundsToPlay) {
          this.endGameMenu = true;
        }
        if (this.rulesFlags.length > 0) {
          let doneRules = this.rulesFlags.filter(flag => flag.round == 0);
          doneRules.forEach(rule => {
            this.displayGameAlert(
              `La regla "` + rule.rule + `" ha sido cumplida`
            );
          });
          this.rulesFlags = this.rulesFlags.filter(flag => flag.round > 0);
          this.rulesFlags.forEach(function(flag) {
            flag.round--;
          });
        }
        return true;
      }
    },
    clearModal() {
      this.modalMsg = "";
      this.showSuggestionMenu = false;
      this.suggestion = false;
      this.displayActiveRules = false;
      this.gameEnded = false;
      this.addNewPlayers = false;
      this.donation = false;
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getRule() {
      this.playing = "rules";
      let randomInt = this.getRandomInt(this.currentRules.length);
      if (
        this.currentRules[randomInt].level <= this.level &&
        this.currentRules[randomInt].type <= this.type
      ) {
        this.populateElements(
          this.currentRules[randomInt].rule,
          "",
          this.currentRules[randomInt].comment
        );
        this.pushRule(this.currentRules[randomInt].rule);
        this.currentRules.splice(randomInt, 1);
      } else {
        if (this.currentRules.length > 0) {
          this.getRule();
        } else {
          this.next();
        }
      }
    },
    getDare() {
      this.playing = "dares";
      let randomInt = this.getRandomInt(this.currentDares.length);
      if (
        this.currentDares[randomInt].level <= this.level &&
        this.currentDares[randomInt].type <= this.type
      ) {
        let dare;
        // Check if dares is for more than one person and if there is enough participants to do it.
        if (
          this.currentDares[randomInt].participants.number >= 2 &&
          this.currentDares[randomInt].participants.number <=
            this.players.length
        ) {
          let participants = this.getParticipants(
            this.currentDares[randomInt].participants
          );
          if (!participants) {
            // This means there is not match for the dare. Ex: Player 1 kiss Player 2 but no orientation match is found.
            this.currentDares.splice(randomInt, 1);
            this.getDare();
          } else {
            dare =
              participants[0].name +
              this.currentDares[randomInt].dare +
              participants[1].name;
            this.populateElements(
              dare,
              "Si alguno de los " +
                participants.length +
                " se rehusa cada uno de ellos deberá beber " +
                this.currentDares[randomInt].fee,
              this.currentDares[randomInt].comment
            );
          }
        } else {
          let otherRandomInt = this.getRandomInt(this.players.length);
          dare =
            this.players[otherRandomInt].name +
            this.currentDares[randomInt].dare;
          this.populateElements(
            dare,
            "ó toma " + this.currentDares[randomInt].fee,
            this.currentDares[randomInt].comment
          );
        }
        this.currentDares.splice(randomInt, 1);
      } else {
        if (this.currentDares.length > 0) {
          this.getDare();
        } else {
          this.next();
        }
      }
    },
    getQuestion() {
      this.playing = "questions";
      let randomInt = this.getRandomInt(this.currentQuestions.length);
      if (
        this.currentQuestions[randomInt].level <= this.level &&
        this.currentQuestions[randomInt].type <= this.type
      ) {
        if (this.que + 1 >= this.players.length) {
          this.que = 0;
        } else {
          this.que++;
        }
        let question =
          this.players[this.que].name +
          this.currentQuestions[randomInt].question;
        this.populateElements(
          question,
          "Responde ó bebe " + this.currentQuestions[randomInt].fee,
          this.currentQuestions[randomInt].comment
        );
        this.currentQuestions.splice(randomInt, 1);
      } else {
        if (this.currentQuestions.length > 0) {
          this.getQuestion();
        } else {
          this.next();
        }
      }
    },
    getGame() {
      this.playing = "games";
      let randomInt = this.getRandomInt(this.currentGames.length);
      if (this.currentGames[randomInt].level > this.level) {
        this.getGame();
      } else {
        // 9 por el orden de los juegos en el games.json. Luego del 9 no empieza nadie en especifico.
        if (randomInt <= 9) {
          let otherRandomInt = this.getRandomInt(this.players.length);
          this.populateElements(
            this.currentGames[randomInt].name,
            "Empieza " + this.players[otherRandomInt].name,
            ""
          );
          this.gameRules = this.currentGames[randomInt].rules;
        } else {
          this.populateElements(this.currentGames[randomInt].name, "", "");
          this.gameRules = this.currentGames[randomInt].rules;
        }
        if (this.currentGames[randomInt].suggestions) {
          this.hasSuggestions = true;
          this.game = randomInt;
        }
      }
    },
    // Posibilidad de escoger la dificultad de la sugerencia -
    // Idea desechada por el momento -> no hay suficientes sugerencias para cada juego y mantener la experiencia entretenida
    // suggestionMenu() {
    //   this.clearModal();
    //   this.modalMsg = "Que tan cabilla?";
    //   this.showSuggestionMenu = true;
    //   this.showModal = true;
    // },
    // getGameSuggestion(level) {
    //   this.showSuggestionMenu = false;
    //   this.suggestion = true;
    //   this.gameLevel = level;
    //   let filtered = this.currentGames[this.game].suggestions.filter(
    //     suggestion =>
    //       suggestion.level == this.gameLevel && suggestion.type == this.type
    //   );
    //   if (filtered.length == 0) {
    //     this.modalMsg = "Se acabaron 😵";
    //     this.suggestion = false;
    //   } else {
    //     let randomInt = this.getRandomInt(filtered.length);
    //     this.modalMsg = filtered[randomInt].statement;
    //     this.modalComment = filtered[randomInt].comment;
    //     filtered.splice(randomInt, 1);
    //     let suggestionIndex = this.currentGames[
    //       this.game
    //     ].suggestions.findIndex(
    //       suggestion => suggestion.statement == filtered.statement
    //     );
    //     this.currentGames[this.game].suggestions.splice(suggestionIndex, 1);
    //   }
    // },
    suggestionMenu() {
      this.clearModal();
      this.showSuggestionMenu = true;
      this.showModal = true;
      this.suggestion = true;
      this.gameLevel = this.level;
      let filtered = this.currentGames[this.game].suggestions.filter(
        suggestion =>
          suggestion.level <= this.gameLevel && suggestion.type == this.type
      );
      if (filtered.length == 0) {
        this.modalMsg =
          "Se acabaron 😵 Sigue jugando para desbloquear nuevas sugerencias";
        this.suggestion = false;
      } else {
        let randomInt = this.getRandomInt(filtered.length);
        this.modalMsg = filtered[randomInt].statement;
        this.modalComment = filtered[randomInt].comment;
        let suggestionIndex = this.currentGames[
          this.game
        ].suggestions.findIndex(
          suggestion => suggestion.statement == filtered[randomInt].statement
        );
        filtered.findIndex(
          suggestion => suggestion.statement == filtered[randomInt].statement
        );
        this.currentGames[this.game].suggestions.splice(suggestionIndex, 1);
      }
    },
    showInstructions() {
      this.clearModal();
      this.displayGameAlert(this.gameRules);
    },
    getParticipants(participants) {
      let players = this.players.map(player => {
        return player;
      });
      let selected = [];
      let randomInt;
      // Orientation doesn't matter
      if (participants.orientation == 0) {
        for (let i = 0; i < participants.number; i++) {
          randomInt = this.getRandomInt(players.length);
          selected.push(players[randomInt]);
          players.splice(randomInt, 1);
        }
        return selected;
      }
      // Same orientation - reciprocal attraction
      if (participants.orientation == 1) {
        randomInt = this.getRandomInt(players.length);
        selected.push(players[randomInt]);
        players.splice(randomInt, 1);
        // If hetero
        if (selected[0].orientation == 1) {
          // filter player of oposite sex and check there is enough for players avalible - else.. try again?
          let filtered = players.filter(
            player =>
              player.sex != selected[0].sex &&
              (player.orientation == 1 || player.orientation == 3)
          );
          if (filtered.length >= participants.number) {
            for (let i = 0; i < participants.number - 1; i++) {
              randomInt = this.getRandomInt(filtered.length);
              selected.push(filtered[randomInt]);
              filtered.splice(randomInt, 1);
            }
            return selected;
          } else {
            this.getDare();
          }
        }
        // If homo
        else if (selected[0].orientation == 2) {
          let filtered = players.filter(
            player =>
              player.sex == selected[0].sex &&
              (player.orientation == 2 || player.orientation == 3)
          );
          if (filtered.length >= participants.number) {
            for (let i = 0; i < participants.number - 1; i++) {
              randomInt = this.getRandomInt(filtered.length);
              selected.push(filtered[randomInt]);
              filtered.splice(randomInt, 1);
            }
            return selected;
          } else {
            this.getDare();
          }
        }
        // If Bi
        if (selected[0].orientation == 3) {
          for (let i = 0; i < participants.number; i++) {
            randomInt = this.getRandomInt(players.length);
            selected.push(players[randomInt]);
            players.splice(randomInt, 1);
          }
          return selected;
        }
      }
      // Oposite orientation - non reciprocal attraction - for the lolz!
      if (participants.orientation == 1) {
        randomInt = this.getRandomInt(players.length);
        selected.push(players[randomInt]);
        players.splice(randomInt, 1);
        // If hetero
        if (selected[0].orientation == 1) {
          let filtered = players.filter(
            player =>
              player.sex == selected[0].sex &&
              (player.orientation == 1 || player.orientation == 3)
          );
          if (filtered.length >= participants.number) {
            for (let i = 0; i < participants.number - 1; i++) {
              randomInt = this.getRandomInt(filtered.length);
              selected.push(filtered[randomInt]);
              filtered.splice(randomInt, 1);
            }
            return selected;
          } else {
            this.getDare();
          }
        }
        // If homo
        else if (selected[0].orientation == 2) {
          let filtered = players.filter(
            player =>
              player.sex != selected[0].sex &&
              (player.orientation == 2 || player.orientation == 3)
          );
          if (filtered.length >= participants.number) {
            for (let i = 0; i < participants.number - 1; i++) {
              randomInt = this.getRandomInt(filtered.length);
              selected.push(filtered[randomInt]);
              filtered.splice(randomInt, 1);
            }
            return selected;
          } else {
            this.getDare();
          }
        }
        // If Bi
        if (selected[0].orientation == 3) {
          for (let i = 0; i < participants.number; i++) {
            randomInt = this.getRandomInt(players.length);
            selected.push(players[randomInt]);
            players.splice(randomInt, 1);
          }
          return selected;
        }
      }
    },
    populateElements(challenge, punishment, comment) {
      this.challenge = challenge;
      this.punishment = punishment;
      this.comment = comment;
    },
    pushRule(rule) {
      let randomInt = this.getRandomInt(7) + 7;
      let newFlag = { rule: rule, round: randomInt };
      this.rulesFlags.push(newFlag);
    },
    seeRules() {
      this.clearModal();
      this.modalMsg = "Reglas Activas";
      if (this.rulesFlags.length == 0 || this.rulesFlags == undefined) {
        this.modalMsg = "No hay reglas activas";
      } else {
        this.displayActiveRules = true;
      }
      this.showModal = true;
    },
    continueGame() {
      this.roundsToPlay = this.roundsToPlay + 10;
      this.showModal = false;
    },
    restartGame() {
      localStorage.removeItem("savedGame");
      document.location.reload(true);
    },
    displayGameAlert(msg) {
      this.modalMsg = msg;
      this.showModal = true;
    },
    showPlayers() {
      this.clearModal();
      let playerList = [];
      if (this.players.length > 0) {
        for (let i = 0; i < this.players.length; i++) {
          playerList.push(" " + this.players[i].name);
        }
        this.displayGameAlert("Ahorita estan jugando:" + playerList.toString());
        this.addNewPlayers = true;
      } else {
        this.displayGameAlert("No hay jugadores! 😟");
      }
    },
    addPlayer() {
      if (this.name.length < 1 || this.sex == 0 || this.orientation == 0) {
        this.modalMsg =
          "Si quieres agregar un nuevo jugador introduce toda la informacion necesaria";
      } else {
        let newPlayer = {
          name: this.name,
          sex: this.sex,
          orientation: this.orientation
        }; // sex : 1 - male , 2 - female ; orientation : 1 - hetero , 2 - homo , 3 - bi
        this.name = "";
        this.sex = 0;
        this.orientation = 0;
        this.players.push(newPlayer);
        let playerList = [];
        for (let i = 0; i < this.players.length; i++) {
          playerList.push(" " + this.players[i].name);
        }
        this.modalMsg = "Ahorita estan jugando: " + playerList.toString();
      }
    },
    deletePlayer() {
      if (this.playerToDelete.length < 1) {
        this.modalMsg = "Si quieres borrar un jugador introduce su nombre";
      } else {
        let playerIndex = this.players.findIndex(
          player => player.name == this.playerToDelete
        );
        if (playerIndex < 0) {
          this.modalMsg = "No hay ningun jugador con ese nombre";
        } else {
          this.players.splice(playerIndex, 1);
          this.modalMsg = this.playerToDelete + " ya no esta jugando";
          this.playerToDelete = null;
        }
      }
    },
    resetGame() {
      this.setterMenu = true;
    },
    showRules() {
      this.clearModal();
      this.displayGameAlert(
        "Es simple! 4 cosas pueden pasar: pregunta, reto, juego, o regla. Solo sigue las instrucciones 😁 **IMPORTANTE**: Si estas bebiendo el licor del mes o alguna de las bebidas de la semana, las reglas que puedan salir en el juego no aplican para ti! Así que revisa en nuestro IG: @seprendio.app!"
      );
    },
    donate() {
      this.clearModal();
      this.modalMsg = "Gracias! Que tipo de donacion quieres hacer?";
      this.donation = true;
      this.showModal = true;
    },
    pay(productsku) {
      // eslint-disable-next-line
      let stripe = Stripe("pk_live_zvufpurjgK10hFrGgK9jt2Rk00AHrcIQFI");
      stripe
        .redirectToCheckout({
          items: [{ sku: productsku, quantity: 1 }],
          successUrl: window.location.href,
          cancelUrl: window.location.href
        })
        .then(function(result) {
          if (result.error) {
            this.clearModal();
            this.modalMsg =
              "Ha ocurrido un error! 😵 La donación no pudo ser procesada";
          } else {
            this.clearModal();
            this.modalMsg =
              "Gracias! 😁 Tu donación ha sido procesada con éxito!";
          }
        });
    }
  }
};
</script>

<style lang="scss">
// Reset CSS
@import "./stylesheets/reset";
// Fonts
@font-face {
  font-family: "Chewy";
  src: url("./assets/fonts/Chewy.ttf") format("truetype");
}
@font-face {
  font-family: "Baloo";
  src: url("./assets/fonts/Baloo.ttf") format("truetype");
}
@font-face {
  font-family: "Rock Salt";
  src: url("./assets/fonts/RockSalt.ttf") format("truetype");
}
// Theme
@import "./stylesheets/theme";

#app {
  background-image: url("./assets/flame.svg"),
    linear-gradient(135deg, #0000, #0000, #000000a3);
  background-position: center;
  background-repeat: no-repeat;
  background-color: color(pColor);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;

  &.games {
    background-color: color(games);
  }
  &.rules {
    background-color: color(rules);
  }
  &.questions {
    background-color: color(questions);
  }
  &.dares {
    background-color: color(dares);
  }

  h1 {
    font-family: font(pFont);
    font-weight: normal;
  }

  h2,
  h3 {
    font-family: font(tFont);
    font-weight: normal;
  }

  h1 {
    font-size: 4.5vh;
    letter-spacing: 2px;
    color: color(white);
  }

  h2 {
    font-size: 3vh;
    color: color(white);
  }

  p {
    font-family: font(sFont);
    color: color(white);
    line-height: 170%;
    font-size: 16px;
  }

  button {
    font-family: font(tFont);
    font-size: 2.5vh;
    border: none;
    border-radius: 100px;
    margin: 0 1%;
    line-height: 200%;
    min-width: 13.5vw;
    cursor: pointer;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

    @include medium {
      min-width: 6vw;
    }

    &.selected {
      background-color: darken($color: color(action), $amount: 10%);
    }

    &:hover {
      background-image: linear-gradient(45deg, #00000050, #00000050);
    }

    &:focus {
      outline: none;
    }
  }
}

#round-number {
  position: absolute;
  top: 3%;
  left: 5%;
  @include medium {
    top: 5%;
    h2 {
      font-size: 6vh;
    }
  }
}

#content {
  align-self: center;
  text-align: center;
  width: 50%;
  display: flex;
  flex-flow: column;

  h1,
  h2 {
    margin-bottom: 7vh;
    align-self: center;
  }

  h2 {
    font-family: font(tFont);
  }
}

#suggestion-btn {
  position: absolute;
  align-self: center;
  bottom: 15vh;
  font-family: "Chewy";
  font-size: 2.5vh;
  background-color: color(white);
  border: none;
  border-radius: 100px;
  padding: 1vh 5vw;

  &:hover {
    background-color: color(lGray);
  }
}

#instructions-btn {
  position: absolute;
  align-self: center;
  bottom: 30vh;
  font-family: "Chewy";
  font-size: 2.5vh;
  background-color: color(white);
  border: none;
  border-radius: 100px;
  padding: 1vh 5vw;

  &:hover {
    background-color: color(lGray);
  }
}

#suggestion-menu {
  display: flex;
  flex-flow: column;
  margin-top: 2vh;

  button {
    margin-bottom: 1vh;
    color: color(dGray);

    &.selected,
    &:hover {
      background-color: color(lGray);
    }
  }
}

#suggestion {
  h4 {
    font-family: font(pFont);
    font-size: 2vh;
    margin: 2vh 5% 3vh 5%;
    color: color(mGray);
    line-height: 120%;
  }

  button {
    padding: 0 3%;
  }
}

#active-rules {
  display: flex;
  position: absolute;
  bottom: 3%;
  left: 5%;
  @include medium {
    bottom: 5%;
    h2 {
      font-size: 6vh;
    }
  }

  h2 {
    align-self: center;
  }

  div {
    align-self: center;
    margin-left: 1vw;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background-color: color(lGray);
    justify-content: center;
    display: flex;
    cursor: pointer;

    @include medium {
      width: 40px;
      height: 40px;
    }

    h3 {
      align-self: center;
      font-size: 2vh;
      color: color(mGray);

      @include medium {
        font-size: 4vh;
      }
    }
  }
}

#active-rules-modal {
  display: flex;
  margin: 2vh 0;
  flex-flow: column;

  p {
    color: color(black);
    font-family: font(tFont);
  }
}

.setting.player {
  background-color: color(success);
  border-radius: 50px;
  padding-bottom: 2vh;
  align-self: center;
  margin-top: 1vh;

  button {
    background-color: lighten($color: color(action), $amount: 25%);
    color: #fff;
  }
}

.delete-player {
  background-color: color(danger);
  border-radius: 50px;
  padding-bottom: 2vh;
  align-self: center;
  margin-top: 1vh;
  flex-flow: column;

  h2 {
    padding: 2vh 0;
  }

  input {
    padding: 1vh 3vw;
    margin-bottom: 1vh;
    border-radius: 100px;
    border: #1fcf4b;
    font-size: 2.5vh;
    font-family: font(tFont);

    &:focus {
      outline: none;
    }
  }

  #delete-btn {
    background-color: darken($color: color(danger), $amount: 15%);
    color: #fff;
    padding: 0 5vw;
  }
}

#logo {
  position: absolute;
  bottom: 3%;
  right: 5%;
  @include medium {
    bottom: 5%;
  }

  img {
    height: 7vh;
    @include medium {
      height: 10vh;
    }
  }
}

#next {
  position: absolute;
  right: 8vw;
  top: calc(50vh - 50px);

  .arrow {
    display: flex;
    flex-flow: column;
    justify-content: center;
    width: 60px;
    height: 100px;

    div {
      height: 9px;
      margin: 4px;
      border-radius: 100px;
      background-color: color(white);
      cursor: pointer;
    }

    .bar-1 {
      transform: rotate(45deg) translate(-10px);
    }

    .bar-2 {
      transform: rotate(-45deg) translate(-10px);
    }
  }
}

#end-menu {
  display: flex;
  flex-flow: column;

  button {
    align-self: center;
    width: 70%;
    margin-top: 2vh;
    color: white;
    background-color: color(action);
  }

  #donate-btn {
    background-image: linear-gradient(to right, #8d2180, #700992);
  }
}

.setting {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;

  &.player {
    flex-flow: column;
  }

  #submit-btn {
    margin-top: 1vh;
    width: 20vh;
    align-self: center;
  }

  h1,
  h2,
  p {
    color: color(black);
    font-family: font(pFont);
  }

  h2 {
    width: 100%;
    margin: 2vh 0;
  }

  .players-settings {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-self: center;

    @include small {
      flex-flow: row;
      flex-flow: wrap;
    }

    .player-info {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: 0.5vh;

      &.sex > p,
      &.orientation > p {
        font-family: font(tFont) !important;
      }

      @include small {
        width: 100%;
        margin-bottom: 2vh;
      }

      input {
        padding: 1vh 3vw;
        border-radius: 100px;
        border: #1fcf4b;
        font-size: 2.5vh;
        font-family: font(tFont);

        &:focus {
          outline: none;
        }
      }

      p {
        width: 100%;

        @include small {
          width: max-content;
        }
      }
    }
  }
}

.checkout-button {
  background-image: linear-gradient(to right, #8d2180, #700992);
  color: #fff;
  font-size: 1.5em;
  padding: 0 20px;
}
</style>
